import React from 'react';
import {StreamBankLink} from "../../Common/StreamBankLink";
import {FileVisibilityHelper} from "../../Common/Files/FileVisibilityHelper";

export const SurveyNameTableColumn = props => {
    const { SurveyType, surveyId } = props.rowData;
    return <div className="cell-with-spaced-content">
        <StreamBankLink
            className="sb-actionable-link"
            Href={"/surveys/" + surveyId}
        >
            {props.Value}
        </StreamBankLink>
        <FileVisibilityHelper file={{
            auditorVisibility: SurveyType?.isHiddenFromAuditor ? false : `${SurveyType?.name} surveys are visible to auditors.`,
            publicVisibility: SurveyType?.isHiddenFromPublic ? false : `${SurveyType?.name} surveys are visible to the public.`,
        }}/>
    </div>;
};
